import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import { ReaderToolType } from 'constants/ReaderTools';
import { BaseReaderStrategy } from './BaseReaderStrategy';

const Blacklist = [
    //ReaderToolType.GobackCatalog,
    ReaderToolType.Activity,
    ReaderToolType.ExportInteractiveObject,
    ReaderToolType.SVG,
    ReaderToolType.RightSideBar,
    ReaderToolType.FullScreen,
    ReaderToolType.NumberPicker,
    ReaderToolType.StickyNote,
    ReaderToolType.Link,
    ReaderToolType.Whiteboard,
    //ReaderToolType.Select
];

export const useOneClassTeacherStrategy = () => {
    const [{ isActive }] = useStore(StoreTypes.canvas);

    const getReaderToolComponents = useCallback((readerToolComponents) => {
        return BaseReaderStrategy.getFilteredReaderToolComponents(readerToolComponents, Blacklist);
    }, []);

    const isReaderSwipeable = useCallback(() => {
        return !isActive;
    }, [isActive]);

    const isReaderSwitchPageAvailable = useCallback(() => {
        return true;
    }, []);

    const syncAnnotation = useCallback((id) => {
        
    }, []);

    const isInteractiveObjectTriggerable = useCallback(({ contentType }) => {
        return true;
    }, []);

    return {
        name: 'useOneClassTeacherStrategy',
        getReaderToolComponents,
        isReaderSwipeable,
        isReaderSwitchPageAvailable,
        syncAnnotation,
        isInteractiveObjectTriggerable
    };
};
